// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"Badge_componentStyle__5JkJX","default":"Badge_default__3vJiE","large":"Badge_large__r7WTl"};